import Vue from 'vue'
import Vuex from 'vuex'
import menu from './modules/menu'
import base from './modules/base'
import auth from './modules/auth'
import app from './modules/app'
import notifications from './modules/notifications'
import companies from './modules/companies'
import locations from './modules/locations'
import certificates from './modules/certificates'
import certcompanies from './modules/certcompanies'
import configurations from './modules/configurations'
import userstatus from './modules/userstatus'
import users from './modules/users'
import userscompanies from './modules/userscompanies'
import companylocations from './modules/companylocations'
import companyothercertificates from './modules/companyothercertificates'

import groups from './modules/groups'
import groupusers from './modules/groupusers'
import grouprules from './modules/grouprules'
import groupgroups from './modules/groupgroups'
import groupcompanies from './modules/groupcompanies'
import groupstatus from './modules/groupstatus'
import neogroups from './modules/neogroups'
import neopresentations from './modules/neopresentations'
import usergroups from './modules/usergroups'

import groupingcompanies from './modules/groupingcompanies'
import groupinglocations from './modules/groupinglocations'
import groupingagencies from './modules/groupingagencies'

import rules from './modules/rules'
import rulegroups from './modules/rulegroups'

import configflow from './modules/configflow'

import orgprovinces from './modules/orgprovinces'
import apirequests from './modules/apirequests'
import procedings from './modules/procedings'

import documentmaster from './modules/documentmaster'

import imports from './modules/imports'

import clients from './modules/clients'
import clientlocations from './modules/clientlocations'

import distributors from './modules/distributors'
import distributorlocations from './modules/distributorlocations'

import historicalCert from './modules/historicalCert'
import historicalUser from './modules/historicalUser'
import historicalGroup from './modules/historicalGroup'
import historicalRule from './modules/historicalRule'
import historicalConfigflow from './modules/historicalConfigflow'
import historicalProceding from './modules/historicalProceding'
import historicalOrgprovinces from './modules/historicalOrgprovinces'
import historicalAPIrequests from './modules/historicalAPIrequests'
import historicalClient from './modules/historicalClient'
import historicalDistributor from './modules/historicalDistributor'
import historicalNEO from './modules/historicalNEO'
import historicalCompany from './modules/historicalCompany'

import trashCertificates from './trashmodules/certificates'
import trashClients from './trashmodules/clients'
import trashCompanies from './trashmodules/companies'
import trashNotifications from './trashmodules/notifications'
import trashUsers from './trashmodules/users'
import trashGroups from './trashmodules/groups'

import trashHistoricalCertificates from './trashmodules/historicalCert'
import trashHistoricalClients from './trashmodules/historicalClient'
import trashHistoricalCompanies from './trashmodules/historicalCompany'
import trashHistoricalNotifications from './trashmodules/historicalNEO'
import trashHistoricalUsers from './trashmodules/historicalUser'
import trashHistoricalGroups from './trashmodules/historicalGroup'

import dashboard from './modules/dashboard'

import aadAuth from './modules/aadAuth'

// Datos de grid persistentes
import notificationsPersisted from './modulesPersisted/notificationsPersisted'
import historicalUserPersisted from './modulesPersisted/historicalUserPersisted'
import historicalGroupPersisted from './modulesPersisted/historicalGroupPersisted'
import historicalRulePersisted from './modulesPersisted/historicalRulePersisted'
import historicalConfigflowPersisted from './modulesPersisted/historicalConfigflowPersisted'
import historicalProcedingPersisted from './modulesPersisted/historicalProcedingPersisted'
import historicalOrgprovincesPersisted from './modulesPersisted/historicalOrgprovincesPersisted'
import historicalAPIrequestsPersisted from './modulesPersisted/historicalAPIrequestsPersisted'
import historicalClientPersisted from './modulesPersisted/historicalClientPersisted'
import historicalCertPersisted from './modulesPersisted/historicalCertPersisted'
import historicalCompanyPersisted from './modulesPersisted/historicalCompanyPersisted'
import historicalNEOPersisted from './modulesPersisted/historicalNEOPersisted'
import companiesPersisted from './modulesPersisted/companiesPersisted'
import locationsPersisted from './modulesPersisted/locationsPersisted'
import companylocationsPersisted from './modulesPersisted/companylocationsPersisted'
import companyothercertificatesPersisted from './modulesPersisted/companyothercertificatesPersisted'
import clientlocationsPersisted from './modulesPersisted/clientlocationsPersisted'
import certificatesPersisted from './modulesPersisted/certificatesPersisted'
import certcompaniesPersisted from './modulesPersisted/certcompaniesPersisted'
import clientsPersisted from './modulesPersisted/clientsPersisted'
import usersPersisted from './modulesPersisted/usersPersisted'
import userscompaniesPersisted from './modulesPersisted/userscompaniesPersisted'
import userstatusPersisted from './modulesPersisted/userstatusPersisted'
import groupsPersisted from './modulesPersisted/groupsPersisted'
import groupusersPersisted from './modulesPersisted/groupusersPersisted'
import groupcompaniesPersisted from './modulesPersisted/groupcompaniesPersisted'
import groupstatusPersisted from './modulesPersisted/groupstatusPersisted'
import groupgroupsPersisted from './modulesPersisted/groupgroupsPersisted'
import neogroupsPersisted from './modulesPersisted/neogroupsPersisted'
import neopresentationsPersisted from './modulesPersisted/neopresentationsPersisted'
import usergroupsPersisted from './modulesPersisted/usergroupsPersisted'
import groupingcompaniesPersisted from './modulesPersisted/groupingcompaniesPersisted'
import groupinglocationsPersisted from './modulesPersisted/groupinglocationsPersisted'
import groupingagenciesPersisted from './modulesPersisted/groupingagenciesPersisted'
import rulesPersisted from './modulesPersisted/rulesPersisted'
import rulegroupsPersisted from './modulesPersisted/rulegroupsPersisted'
import configflowPersisted from './modulesPersisted/configflowPersisted'
import orgprovincesPersisted from './modulesPersisted/orgprovincesPersisted'
import apirequestsPersisted from './modulesPersisted/apirequestsPersisted'
import procedingsPersisted from './modulesPersisted/procedingsPersisted'
import documentmasterPersisted from './modulesPersisted/documentmasterPersisted'
import importsPersisted from './modulesPersisted/importsPersisted'
import distributorsPersisted from './modulesPersisted/distributorsPersisted'
import distributorlocationsPersisted from './modulesPersisted/distributorlocationsPersisted'
import historicalDistributorPersisted from './modulesPersisted/historicalDistributorPersisted'
import trashUsersPersisted from './modulesPersisted/trashUsersPersisted'
import trashHistoricalUsersPersisted from './modulesPersisted/trashHistoricalUsersPersisted'
import trashNotificationsPersisted from './modulesPersisted/trashNotificationsPersisted'
import trashHistoricalNotificationsPersisted from './modulesPersisted/trashHistoricalNotificationsPersisted'
import trashCertificatesPersisted from './modulesPersisted/trashCertificatesPersisted'
import trashHistoricalCertificatesPersisted from './modulesPersisted/trashHistoricalCertificatesPersisted'
import trashCompaniesPersisted from './modulesPersisted/trashCompaniesPersisted'
import trashHistoricalCompaniesPersisted from './modulesPersisted/trashHistoricalCompaniesPersisted'
import trashGroupsPersisted from './modulesPersisted/trashGroupsPersisted'
import trashHistoricalGroupsPersisted from './modulesPersisted/trashHistoricalGroupsPersisted'
import trashClientsPersisted from './modulesPersisted/trashClientsPersisted'
import trashHistoricalClientsPersisted from './modulesPersisted/trashHistoricalClientsPersisted'

import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

const authState = createPersistedState({
  paths: [
    'auth',
    'app',
    'base',
    'menu',
    'notificationsPersisted',
    'historicalUserPersisted',
    'historicalGroupPersisted',
    'historicalRulePersisted',
    'historicalConfigflowPersisted',
    'historicalProcedingPersisted',
    'historicalOrgprovincesPersisted',
    'historicalAPIrequestsPersisted',
    'historicalClientPersisted',
    'historicalCertPersisted',
    'historicalCompanyPersisted',
    'historicalNEOPersisted',
    'companiesPersisted',
    'locationsPersisted',
    'companylocationsPersisted',
    'companyothercertificates',
    'clientlocationsPersisted',
    'certificatesPersisted',
    'certcompaniesPersisted',
    'clientsPersisted',
    'usersPersisted',
    'userscompaniesPersisted',
    'userstatusPersisted',
    'groupsPersisted',
    'groupusersPersisted',
    'groupcompaniesPersisted',
    'groupstatusPersisted',
    'groupgroupsPersisted',
    'neogroupsPersisted',
    'neopresentationsPersisted',
    'usergroupsPersisted',
    'groupingcompaniesPersisted',
    'groupinglocationsPersisted',
    'groupingagenciesPersisted',
    'rulesPersisted',
    'rulegroupsPersisted',
    'configflowPersisted',
    'orgprovincesPersisted',
    'apirequestsPersisted',
    'procedingsPersisted',
    'documentmasterPersisted',
    'importsPersisted',
    'distributorsPersisted',
    'distributorlocationsPersisted',
    'historicalDistributorPersisted',
    'trashUsersPersisted',
    'trashHistoricalUsersPersisted',
    'trashNotificationsPersisted',
    'trashHistoricalNotificationsPersisted',
    'trashCertificatesPersisted',
    'trashHistoricalCertificatesPersisted',
    'trashCompaniesPersisted',
    'trashHistoricalCompaniesPersisted',
    'trashGroupsPersisted',
    'trashHistoricalGroupsPersisted',
    'trashClientsPersisted',
    'trashHistoricalClientsPersisted',
  ],
  rehydrated: rehydrated
})

const stp = (store) => {
  store.subscribe((mutation, state) => {
    switch (mutation.type) {
      case 'app/setNavigationFromMenu':
        if (mutation.payload === true) {
          const _resetModules = ['base']
          _resetModules.forEach(element => {
            store.commit(element + '/setCurrentPage', 1)
            store.commit(element + '/resetMasterFilters')
            store.commit(element + '/resetPaginationInfo')
            if (element === 'communications') {
              store.commit(element + '/resetSelectedUserForCommunication')
            }
            state.app.navFromMenu = false
          })
        }
        break
    }
  })
}

export default new Vuex.Store({
  state: {
    isLoading: false,
    headCoreReady: false,
    ajaxQueryPending: false,
    lastAjaxResult: ''
  },
  mutations: {
    setIsLoading (state, status) {
      state.isLoading = status
    },
    setHeadCoreStatus (state, status) {
      state.headCoreReady = status
    },
    setAjaxRequestPending (state, status) {
      state.ajaxQueryPending = status
    },
    setLastAjaxResult (state, status) {
      state.lastAjaxResult = status
    }
  },
  getters: {
    isLoading: state => state.isLoading,
    isHeadCoreReady: state => state.headCoreReady,
    isAjaxQueryPending: state => state.ajaxQueryPending,
    lastAjaxResult: state => state.lastAjaxResult
  },
  modules: {
    menu,
    base,
    notifications,
    companies,
    locations,
    certificates,
    certcompanies,
    configurations,
    users,
    groups,
    groupusers,
    grouprules,
    groupgroups,
    groupcompanies,
    groupstatus,
    neogroups,
    neopresentations,
    usergroups,
    groupingcompanies,
    groupinglocations,
    groupingagencies,
    rules,
    rulegroups,
    configflow,
    orgprovinces,
    apirequests,
    procedings,
    documentmaster,
    imports,
    userscompanies,
    userstatus,
    companylocations,
    companyothercertificates,
    clients,
    clientlocations,
    distributors,
    distributorlocations,
    historicalCert,
    historicalUser,
    historicalGroup,
    historicalRule,
    historicalConfigflow,
    historicalProceding,
    historicalOrgprovinces,
    historicalAPIrequests,
    historicalClient,
    historicalDistributor,
    historicalNEO,
    historicalCompany,
    trashCertificates,
    trashClients,
    trashCompanies,
    trashNotifications,
    trashUsers,
    trashGroups,
    trashHistoricalUsers,
    trashHistoricalGroups,
    trashHistoricalCertificates,
    trashHistoricalClients,
    trashHistoricalCompanies,
    trashHistoricalNotifications,
    auth,
    app,
    aadAuth,
    dashboard,
    //
    notificationsPersisted,
    historicalUserPersisted,
    historicalGroupPersisted,
    historicalRulePersisted,
    historicalConfigflowPersisted,
    historicalProcedingPersisted,
    historicalOrgprovincesPersisted,
    historicalAPIrequestsPersisted,
    historicalClientPersisted,
    historicalCertPersisted,
    historicalCompanyPersisted,
    historicalNEOPersisted,
    companiesPersisted,
    locationsPersisted,
    companylocationsPersisted,
    companyothercertificatesPersisted,
    clientlocationsPersisted,
    certificatesPersisted,
    certcompaniesPersisted,
    clientsPersisted,
    usersPersisted,
    userscompaniesPersisted,
    userstatusPersisted,
    groupsPersisted,
    groupusersPersisted,
    groupcompaniesPersisted,
    groupstatusPersisted,
    groupgroupsPersisted,
    neogroupsPersisted,
    neopresentationsPersisted,
    usergroupsPersisted,
    groupingcompaniesPersisted,
    groupinglocationsPersisted,
    groupingagenciesPersisted,
    rulesPersisted,
    rulegroupsPersisted,
    configflowPersisted,
    orgprovincesPersisted,
    apirequestsPersisted,
    procedingsPersisted,
    documentmasterPersisted,
    importsPersisted,
    distributorsPersisted,
    distributorlocationsPersisted,
    historicalDistributorPersisted,
    trashUsersPersisted,
    trashHistoricalUsersPersisted,
    trashNotificationsPersisted,
    trashHistoricalNotificationsPersisted,
    trashCertificatesPersisted,
    trashHistoricalCertificatesPersisted,
    trashCompaniesPersisted,
    trashHistoricalCompaniesPersisted,
    trashGroupsPersisted,
    trashHistoricalGroupsPersisted,
    trashClientsPersisted,
    trashHistoricalClientsPersisted,
  },
  plugins: [authState, stp]
})

function rehydrated ({ getters }) {
  const darkMode = getters['app/darkMode']
  if (darkMode === false) {
    document.body.classList.remove('dark')
  } else {
    document.body.classList.add('dark')
  }
}
